import { FC, useLayoutEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";

import MainLayout from "../../layout/MainLayout/MainLayout";
import { selectAuthUser } from "../../store/selectors/auth";
import { DEFAULT_AUTHENTICATED_ROUTE } from "../../constants/routes";



const PaymentSuccessView: FC = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectAuthUser);
  const hasTracked = useRef(false);
  const navigate = useNavigate();


  useLayoutEffect(() => {
    if (!hasTracked.current) {
      hasTracked.current = true;

      window.gtag?.('event', 'conversion', {
        'send_to': 'AW-17034515099/ZsTWCP-N5_IaEJul2Lo_',
        'value': 1.0,
        'currency': 'USD'
      });

      window.dataLayer?.push({
        'event': 'registration_success',
        'user_id': user?.id,
      });
    }

    navigate(DEFAULT_AUTHENTICATED_ROUTE, { replace: true });
  }, [dispatch, user, navigate]);


  return <MainLayout />;
};

export default PaymentSuccessView;
